import React, { useState } from 'react';
import {
  ACCESS_CODE,
  formatAccessDigits,
  parseAccessInput,
} from '../utils/accessCode';

const AccessScreen = ({ onSuccess }) => {
  const [digits, setDigits] = useState('');
  const [error, setError] = useState('');

  const handleChange = (event) => {
    setDigits(parseAccessInput(event.target.value));
    setError('');
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (digits.length !== 6) {
      setError('Enter the 6-digit access code.');
      return;
    }

    if (digits !== ACCESS_CODE) {
      setError('Invalid access code.');
      return;
    }

    onSuccess();
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md flex flex-col items-center gap-8"
      >
        <h1 className="flex items-center gap-2 text-3xl font-bold text-gray-900">
          <i className="fa-solid fa-key text-orange-500" />
          Passswords
        </h1>

        <input
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          value={formatAccessDigits(digits)}
          onChange={handleChange}
          placeholder="0 - 0 - 0 - 0 - 0 - 0"
          className="w-full border border-gray-800 rounded-lg px-4 py-3 text-center text-lg tracking-widest outline-none focus:border-orange-500"
          aria-label="Access code"
        />

        {error && (
          <p className="text-sm text-red-600 -mt-4">{error}</p>
        )}

        <button
          type="submit"
          className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg py-3 text-lg"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default AccessScreen;
